export default "<button class=\"btn btn-default\" (click)=\"open()\" translate>Register</button>\n";